import { FlexRow, TextInput, FlexCell, Panel, Tag, Text } from '@epam/promo';
import { useState } from 'react';
import { TagsInputProps } from './TagsInput.model';
import css from './TagsInput.module.scss';
import { TAGS_MAX_QUANTITY, MAX_TAG_LENGTH } from './constants';

export const TagsInput = ({
  isOptionSelected,
  isDisabled,
  tagsList,
  inputValue,
  errorMessage,
  maxAllowedTags = TAGS_MAX_QUANTITY,
  maxTagLength = MAX_TAG_LENGTH,
  pushToList,
  removeItemFromList,
  updateInputValue,
}: TagsInputProps) => {
  const [isInputShowed, setInputShowed] = useState(false);

  const isInputAvailable =
    !isDisabled &&
    (isOptionSelected || isInputShowed) &&
    tagsList.length < maxAllowedTags;

  const handleBlur = (value: string) => {
    setInputShowed(false);
    updateInputValue(value.trim());
  };

  return (
    <>
      <FlexRow
        cx={`${css['form__input-group']}
          ${!tagsList.length && !isOptionSelected ? css.hidden : ''}
          ${isDisabled ? css.disabled : ''}
          `}>
        <FlexCell grow={20} onClick={() => setInputShowed(true)}>
          <Panel
            cx={`${css['form__tags-list']} ${isDisabled && css.disabled} `}>
            {tagsList.map((tag: string) => (
              <Tag
                key={tag}
                caption={tag}
                cx={css.form__tag}
                isDisabled={isDisabled}
                size="24"
                onClear={() => removeItemFromList(tag)}
              />
            ))}
          </Panel>
          <Text color="gray60" cx={css['form__tags-count']} fontSize="12">
            {tagsList?.length || 0}/{maxAllowedTags} answers
          </Text>
          {isInputAvailable && (
            <div className={css['form__input-container']}>
              <TextInput
                cx={`${css['form__tag-input']}`}
                inputMode="text"
                isInvalid={!!errorMessage}
                maxLength={maxTagLength}
                placeholder={`Type an answer (max ${maxTagLength} symbols) and press Enter to add it.`}
                size="36"
                value={inputValue}
                onBlur={() => handleBlur(inputValue)}
                onKeyDown={pushToList}
                onValueChange={updateInputValue}
              />
              {inputValue?.length && (
                <Text
                  color="gray60"
                  cx={css['form__symbols-count']}
                  fontSize="10">
                  {inputValue?.length || 0}/{maxTagLength}
                </Text>
              )}
            </div>
          )}
        </FlexCell>
      </FlexRow>
      {isOptionSelected && errorMessage && (
        <Text cx={css['form__invalid-message']}>{errorMessage}</Text>
      )}
    </>
  );
};
